// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VALfx","left":"styles_left__xv-qW","right":"styles_right__mvCaS","alert":"styles_alert__PJNfj"};